"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDismissNotification;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useDismissNotification() {
  return (0, _useWebChatAPIContext.default)().dismissNotification;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VEaXNtaXNzTm90aWZpY2F0aW9uLnRzIl0sIm5hbWVzIjpbInVzZURpc21pc3NOb3RpZmljYXRpb24iLCJkaXNtaXNzTm90aWZpY2F0aW9uIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxzQkFBVCxHQUF3RDtBQUNyRSxTQUFPLHFDQUF1QkMsbUJBQTlCO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL2ludGVybmFsL3VzZVdlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlRGlzbWlzc05vdGlmaWNhdGlvbigpOiAoaWQ6IHN0cmluZykgPT4gdm9pZCB7XG4gIHJldHVybiB1c2VXZWJDaGF0QVBJQ29udGV4dCgpLmRpc21pc3NOb3RpZmljYXRpb247XG59XG4iXX0=